const dividerPattern = /^-{8,}$/;
const operationPattern = /^(SALE|REFUND)$/i;

/**
 * Compacts legacy terminal receipt text for the small POS viewport without
 * dropping transaction evidence. New receipts already use this shape, while
 * stored receipts are normalised when displayed.
 */
export function compactPdqReceipt(receiptText: string): string {
  const lines = receiptText
    .replaceAll("\r", "")
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line && !dividerPattern.test(line));
  const compact: string[] = [];
  const cvm = lines.find((line) => /^CVM:\s*/i.test(line))?.replace(/^CVM:\s*/i, "").trim();

  for (let index = 0; index < lines.length; index += 1) {
    const line = lines[index];
    const next = lines[index + 1];
    if (/^PAYMENT RECEIPT$/i.test(line) && operationPattern.test(next ?? "")) {
      compact.push(`PAYMENT RECEIPT · ${next.toUpperCase()}`);
      index += 1;
      continue;
    }
    if (/^CUSTOMER RECEIPT$/i.test(line) && next) {
      compact.push(`CUSTOMER RECEIPT · ${next}`);
      index += 1;
      continue;
    }
    if (/^(AUTHORISED|DECLINED)$/i.test(line)) {
      compact.push(`${line.toUpperCase()}${cvm ? ` · ${cvm}` : ""}`);
      if (cvm && next?.toUpperCase() === cvm.toUpperCase()) index += 1;
      continue;
    }
    compact.push(line
      .replace(/^APPROVAL CODE:/i, "AUTH:")
      .replace(/^RESPONSE CODE:/i, "RESPONSE:")
      .replace(/^REFERENCE:/i, "REF:")
      .replace(/^TRANSACTION ID:/i, "TXN:"));
  }
  return compact.join("\n");
}
